module.exports = __webpack_public_path__ + "img/rynenation-logo-light-large.a50dd28c.png";